import React from 'react';
import toast from 'react-hot-toast';
import { Input } from '../../components';
import { classNames } from '../../utils';
import { AuthService } from '../../services';
import { BackIcon } from '../../assets/icons';

class Recover extends React.Component {

	state = {
		form: {
			email: ''
		}
	}

	change = (value,target) => {
		this.setState({
			form: {
				...this.state.form,
				[target]: value
			}
		});
	}

	submit = async () => {
		if (!this.isValidForm()) return;

		try {
			await AuthService.recover(this.state.form);
			toast.success("Se le ha enviado un correo electrónico para la recuperación de contraseña");
			this.props.history.replace('/');

		} catch (error) {
			
		}
	}

	isValidForm = (showError = true) => {
		const onError = (msg) => {
			if (showError) toast.error(msg);
			return false;
		}

		const { form } = this.state;

		if (!form.email )
			return onError('El correo es obligatorio');

		if (!String(form.email).match(/^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,3}$/ig))
			return onError('El correo no es válido');

		return true;
	}

	render() {

		const isNextStepEnabled = this.isValidForm(false);

		return (
			<>
				<button className="flex items-center gap-2 ml-4 mt-4" onClick={() => this.props.history.replace('/')}>
					<img src={BackIcon} className="w-4 h-4 object-contain invert" alt="" />
					<span className="text-center font-semibold">Iniciar sesión</span>
				</button>

				<p className="text-center font-semibold text-xl">
					Recuperar Contraseña
				</p>

				<div className="max-w-[400px] mx-auto my-8 flex flex-col gap-4 px-4">
					<p className="text-center px-4 font-semibold">
						Ingrese su correo electrónico y recibirá un código de acceso
					</p>

					<Input
						placeholder="Correo electrónico"
						value={this.state.form.email}
						onValueChange={e => this.change(e,'email')}
					/>

					<button
						className={classNames(
							'rounded-lg w-full text-center h-10 font-bold text-lg my-2 disabled:bg-gray6 disabled:text-gray3',
							isNextStepEnabled ? 'bg-green text-white' : 'bg-gray text-gray6'
						)}
						onClick={this.submit}
					>
						<span>Siguiente</span>
					</button>
				</div>
			</>
		)
	}
}

export default Recover;